import React, { useState, useEffect } from 'react';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import ReactTable from 'components/ReactTable/ReactTable';
import { WithApp } from 'contexts/appContext';
import { useParams } from 'react-router-dom';
import { wsGet } from 'services/WService';
import moment from 'moment';

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 150 },
  { Header: 'Número Guía', accessor: 'GuideNumber', width: 150 },
  { Header: 'Documento', accessor: 'document', width: 400 },
  { Header: 'Impresiones', accessor: 'print_count', width: 200 },
  { Header: 'Usuario', accessor: 'oauth_user_name', width: 200 },
  { Header: 'Fecha Impresión', accessor: 'created_at', width: 200 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

function ReferalGuideDetail(props) {
  const { id } = useParams();

  const [guideSerie, setGuideSerie] = useState();
  const [guides, setGuides] = useState([]);

  useEffect(() => {
    wsGet('prt/guide-serie', id).then((response) => {
      let { guides, ...guideSerie } = response.data;
      setGuideSerie(guideSerie);
      setGuides(guides);
    });
  }, []);

  return (
    <CardContainer
      title={
        guideSerie === undefined
          ? 'Cargando...'
          : `Guía serie ${guideSerie.base_zone_description} ${guideSerie.initial_number} => ${guideSerie.last_number}`
      }
    >
      {guideSerie !== undefined && (
        <>
          <h4>Estado: {guideSerie.state === 'A' ? 'Activo' : 'Inactivo'}</h4>
          <h4>
            Siguiente número: {guideSerie.state === 'I' ? 'Inactivo' : guideSerie.next_number}
          </h4>
        </>
      )}

      <ReactTable columns={columns} data={guides.map((guide, i) => {
        return {
          num: i + 1,
          GuideNumber: guide.GuideNumber,
          document: `${guide.ReceiptSerie} - ${guide.ReceiptNumber}`,
          print_count: guide.print_count,
          oauth_user_name: guide.oauth_user_name,
          created_at: moment(guide.created_at).format('DD/MM/YYYY hh:mm:ss'),
        };
      })}/>
    </CardContainer>
  );
}

export default WithApp(ReferalGuideDetail);
